<template>
  <loading-view :loading="initialLoadingCoveredFlows">
    <div v-for="(data, idx) in coveredFlows" :key="`coveredFlow-${idx}`" class="pt-2 pb-4 tile mb-8">
      <div>
        <div class="form_row">
          <form-input-header :description="data.group.translated_description" :header="data.group.translated_name"/>
          <div v-if="data.flows" class="price_cell">
            <span class="price">€ {{ getPrice(getSelectedFlowByGroup(data.group) || data.flows[0]) }}</span>
            <span class="price_rate"> / {{ trans('common.month') }}</span>
          </div>
        </div>
        <div v-for="(flow, fIdx) in data.flows" :key="`flow-${fIdx}-${idx}`" class="my-4">
          <input
            :id="`check-${fIdx}-${idx}`"
            v-model="selectedCoveredFlows"
            :value="flow"
            class="form_knob_check"
            type="checkbox"
            @change="removeOtherFlow(flow)"
          />
          <label :for="`check-${fIdx}-${idx}`" class="form_knob m-0 w-100">
            <input :value="flow.sentenceFlow" class="form_field m-0" disabled type="text"/>
            <input
              :value="flow.dependency.sentenceFlow"
              class="form_field m-0 ml-2"
              disabled
              type="text"
            />
          </label>
        </div>
      </div>
    </div>
    <div v-if="!isFromWizard" class="flex justify-around mt-6 mb-2 tile">
      <div class="flex inline-flex w-1/2 mx-4 form_row">
        <label class="inline-block text-80 pt-2 leading-tight w-1/3">
          {{ trans('dashboard.integrations.configure_flows.current_monthly_fees') }}
        </label>
        <div class="price_cell">
          <span class="price">€ {{ currentMonthlyFees.toFixed(2) }}</span>
          <span class="price_rate"> / {{ trans('common.month') }}</span>
        </div>
      </div>
      <div class="flex inline-flex w-1/2 mx-4 form_row">
        <label class="inline-block text-80 pt-2 leading-tight w-1/3">
          {{ trans('dashboard.integrations.configure_flows.new_monthly_fees') }}
        </label>
        <div class="price_cell">
          <span class="price">€ {{ newMonthlyFees.toFixed(2) }}</span>
          <span class="price_rate"> / {{ trans('common.month') }}</span>
        </div>
      </div>
    </div>
    <div v-else class="flex justify-end mt-6 mb-2 tile">
      <div class="flex justify-end w-1/2 mx-4">
        <label class="inline-block text-80 pt-2 leading-tight w-1/3">{{ trans('common.total') }}</label>
        <div class="price_cell">
          <span class="price">€ {{ newMonthlyFees.toFixed(2) }}</span>
          <span class="price_rate"> / {{ trans('common.month') }}</span>
        </div>
      </div>
    </div>
  </loading-view>
</template>

<script>
import FormInputHeader from './FormInputHeader';

export default {
  name: 'ConfigureFlow',

  components: {
    FormInputHeader,
  },

  props: {
    integrationIdProp: {
      default: null,
    },

    userIdProp: {
      default: null,
    },

    isFromWizard: {
      type: Boolean,
      default: false,
    },
  },

  async beforeMount() {
    await axios
      .get(`${this.baseApi}/flows`)
      .then(({data}) => {
        this.coveredFlows = data.data;
        this.selectedCoveredFlows = _.filter(_.flatten(_.map(data.data, group => group.flows)), flow => flow.selected);
        this.currentMonthlyFees = _.sumBy(this.selectedCoveredFlows, coveredFlows => this.getPrice(coveredFlows));
      })
      .catch(({response}) => this.handleError(response.data));
    this.initialLoadingCoveredFlows = false;
  },

  data() {
    return {
      initialLoadingCoveredFlows: true,
      coveredFlows: [],
      selectedCoveredFlows: [],
      currentMonthlyFees: 0,
    };
  },

  computed: {
    integrationId() {
      return this.integrationIdProp || this.$route().params.integration;
    },

    userId() {
      return this.userIdProp || this.$route().params.user;
    },

    baseApi() {
      return `/user/${this.userId}/integration/${this.integrationId}`;
    },

    newMonthlyFees() {
      return _.sumBy(this.selectedCoveredFlows, coveredFlows => this.getPrice(coveredFlows));
    },
  },

  watch: {
    selectedCoveredFlows(current) {
      this.$emit('selected-flows', current);
    },
  },

  methods: {
    getPrice(flow) {
      const flow1Price = flow.pivot.override_default_price ? flow.pivot.price : flow.default_price;

      const flow2Price = flow.dependency.pivot.override_default_price
        ? flow.dependency.pivot.price
        : flow.dependency.default_price;

      const price = flow1Price + flow2Price;

      return parseFloat(price.toFixed(2));
    },

    removeOtherFlow(flow) {
      _.remove(
        this.selectedCoveredFlows,
        selectedFlow => selectedFlow.id === flow.dependency_id && selectedFlow.dependency_id === flow.id,
      );
    },

    getSelectedFlowByGroup(group) {
      return _.find(this.selectedCoveredFlows, {group_id: group.id});
    }
  },
};
</script>

<style scoped></style>
